export default {
  showAlarms: 'Pokaż alarmy',
  showStages: 'Pokaż sceny',
  showMarkers: 'Pokaż znaczniki',
  showHoverPoints: 'Pokaż najechane punkty',
};
